import { render, staticRenderFns } from "./Notenart.vue?vue&type=template&id=452792ae&"
import script from "./Notenart.vue?vue&type=script&lang=js&"
export * from "./Notenart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports